import triggerBonus from "./getTriggerBonusReducer"
import sendTriggerBonus from "./sendTriggerBonusReducer"

export default {
    triggerBonus,
    sendTriggerBonus,
}
